var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutorias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.17 96.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03342f;}.cls-2{fill:#b4192c;}.cls-3,.cls-6{fill:none;stroke-miterlimit:10;}.cls-3{stroke:#000;}.cls-4{fill:#ffe834;}.cls-5{fill:#fffdfe;}.cls-6{stroke:#fffdfe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector_logop",
    "data-name": "vector logop"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.27 96.91 60.58 87.47 59.8 27.71 41.27 34.86 41.27 96.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.27 34.86 25.07 27.17 0.72 55.28 17.88 83.22 41.27 83.45 41.27 34.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "88.44 16.66 88.44 36.21 74.52 41.36 58.91 58.45 58.91 85.63 74.52 64.4 74.52 51.73 88.44 36.21 88.44 74.2 41.27 96.66 41.27 77.71 52.52 83.93 57.8 86.86 57.8 42.48 60.02 42.11 64.86 43.57 60.77 37.65 54.09 37.65 50.91 56.13 43.3 53.25 41.27 54.32 41.27 34.86 88.44 16.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "88.44 36.21 74.52 51.73 74.52 64.4 58.91 85.63 58.91 58.45 74.52 41.36 88.44 36.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.73 62.49 0.72 55.28 0.21 15.36 28.91 28.99 29.27 59.22 20.73 62.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.27 77.71 41.27 96.91 0.95 73.31 0.72 55.28 41.27 77.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.27 34.86 41.27 54.32 35.49 32.12 41.27 34.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0.21 15.36 28.64 5.72 28.91 28.99 0.21 15.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "88.44 16.66 41.27 34.86 35.49 32.12 28.64 5.72 45.49 0 88.44 16.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "88.44 36.21 74.52 51.73 74.52 64.4 58.91 85.63 58.91 58.45 74.52 41.36 88.44 36.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "41.13 53.85 29.39 58.64 29.05 29.07 28.77 6.3 35.48 32.13 41.13 53.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "49.44 72.37 40.66 77.22 3.08 56.04 21.64 62.85 29.54 59.76 40.66 66.81 49.44 72.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "64.86 43.57 60.02 42.11 57.8 42.48 57.8 86.86 52.52 83.93 50.73 72.57 41.27 66.68 29.27 59.22 41.27 54.32 43.3 53.25 50.91 56.13 54.09 37.65 60.77 37.65 64.86 43.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "52.03 83.45 41.27 77.49 41.27 77.49 50.34 72.57 52.03 83.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 52.59,
    y1: 84.46,
    x2: 52.51,
    y2: 83.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "0.21 35.05 41.27 54.55 88.44 36.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "0.21 55.48 41.27 74.99 88.44 56.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 57.05,
    y1: 28.73,
    x2: 58.54,
    y2: 88.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 72.63,
    y1: 22.76,
    x2: 74.59,
    y2: 80.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 27.02,
    y1: 28.09,
    x2: 27.02,
    y2: 88.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 12.67,
    y1: 80.18,
    x2: 12.67,
    y2: 21.07
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorias);
export default __webpack_public_path__ + "static/media/tutorias.63f180c0c163be67c3eb44873c501085.svg";
export { ForwardRef as ReactComponent };